import React from 'react';
import { TopBar } from './components/TopBar';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { WhyFailedSection } from './components/WhyFailedSection';
import { MechanismSection } from './components/MechanismSection';
import { WhatYouGetSection } from './components/WhatYouGetSection';
import { WhoForSection } from './components/WhoForSection';
import { HowItWorksSection } from './components/HowItWorksSection';
import { ProofSection } from './components/ProofSection';
import { FAQSection } from './components/FAQSection';
import { OfferSection } from './components/OfferSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-zinc-950 text-zinc-100 selection:bg-teal-500/30" data-id="element-0">
      <TopBar data-id="element-1" />
      <Header data-id="element-2" />
      <main data-id="element-3">
        <Hero data-id="element-4" />
        <ProblemSection data-id="element-5" />
        <WhyFailedSection data-id="element-6" />
        <MechanismSection data-id="element-7" />
        <WhatYouGetSection data-id="element-8" />
        <WhoForSection data-id="element-9" />
        <HowItWorksSection data-id="element-10" />
        <ProofSection data-id="element-11" />
        <FAQSection data-id="element-12" />
        <OfferSection data-id="element-13" />
      </main>
      <Footer data-id="element-14" />
    </div>;
}